// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kQ4R","largestCol":"styles_largestCol__1ZQ3-","smallestCol":"styles_smallestCol__FcajP"};